import ConfigPanel from 'dashboard/apps/InquiryTemplateEditor/ConfigPanel';
import { InquiryTemplateVersionStepComplete } from 'dashboard/models/inquiry-template-version';

const defaultStepDescription = 'Non-UI step that completes and exits the flow';

interface CompleteStepPanelProps {
  step: InquiryTemplateVersionStepComplete;
  stepIndex: number;
  editable: boolean;
  handleClose: () => void;
}

const CompleteStepPanel = ({ step, stepIndex, editable, handleClose }: CompleteStepPanelProps) => {
  return (
    <ConfigPanel
      name='steps'
      panelType={step.type}
      fieldsBase={`${stepIndex}`}
      title={step.name}
      description={defaultStepDescription}
      handleClose={handleClose}
      editable={editable}
    />
  );
};

export default CompleteStepPanel;
